<template>
    <div class="view-inner">
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-border text-light" role="status"></div>
            <p>Cargando...</p>
        </div>

        <!-- Page Header -->
        <div class="page-header">
            <h1 class="page-header-title"><i class="bi bi-send"></i> Gestión de Métodos de Envío</h1>
            <div class="page-header-actions">
                <button class="btn-add" @click="abrirModalMetodoEnvio()">
                    <i class="bi bi-plus-lg"></i> Agregar Método
                </button>
            </div>
        </div>

        <!-- Tabla (estándar: ESTANDAR_LISTADOS.md) -->
        <div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                                <th>ID</th>
                                <th>Código</th>
                                <th>Fecha Creación</th>
                                <th>Fecha Actualización</th>
                                <th class="col-acciones">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="metodo in paginar(metodosEnvio)" :key="metodo.id">
                                <td class="celda-id">{{ metodo.id }}</td>
                                <td class="celda-id">{{ metodo.codigo }}</td>
                                <td class="celda-id">{{ formatearFecha(metodo.created_at) }}</td>
                                <td class="celda-id">{{ formatearFecha(metodo.updated_at) }}</td>
                                <td class="col-acciones">
                                    <button class="btn-icon btn-icon-view" @click="verDetalles(metodo)" title="Ver detalles" aria-label="Ver detalles">
                                        <i class="bi bi-eye"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-edit" @click="editarMetodoEnvio(metodo)" title="Editar" aria-label="Editar">
                                        <i class="bi bi-pencil"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-del" @click="eliminarMetodoEnvio(metodo.id)" title="Eliminar" aria-label="Eliminar">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="!metodosEnvio.length" class="empty-row">
                                <td colspan="5">No se encontraron métodos de envío</td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <PaginacionListado :pagina="paginaActualDe(metodosEnvio)" :total-paginas="totalPaginasDe(metodosEnvio)"
                :total="metodosEnvio.length" :por-pagina="porPagina" :en-pagina="paginar(metodosEnvio).length"
                etiqueta="métodos de envío" @cambiar="pagina = $event" />
        </div>

        <!-- Modal para Método de Envío -->
        <div v-if="showModalMetodo" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ modoEdicion ? 'Editar Método de Envío' : 'Nuevo Método de Envío' }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalMetodo"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="guardarMetodoEnvio">
                            <div class="mb-3">
                                <label for="codigo" class="form-label required">Código</label>
                                <input 
                                    type="text" 
                                    class="form-control" 
                                    id="codigo" 
                                    v-model="formMetodo.codigo"
                                    :class="{ 'is-invalid': errors.codigo }"
                                    placeholder="Ingrese el código del método"
                                    maxlength="255"
                                    required
                                >
                                <div v-if="errors.codigo" class="invalid-feedback">
                                    {{ errors.codigo }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalMetodo">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="guardarMetodoEnvio" :disabled="isLoading">
                            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                            {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para Gestión de Detalles -->
        <div v-if="showModalDetalles" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Gestión de Detalles - {{ metodoSeleccionado?.codigo }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalDetalles"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Botón para agregar nuevo detalle -->
                        <div class="mb-3">
                            <button class="btn btn-success" @click="abrirModalDetalle()">
                                <i class="bi bi-plus"></i> Agregar Detalle
                            </button>
                        </div>
                        
                        <!-- Tabla de detalles -->
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Detalle</th>
                                        <th>Es Documento</th>
                                        <th>Es Recojo</th>
                                        <th>Fecha Creación</th>
                                        <th class="col-acciones">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="detalle in detallesEnvio" :key="detalle.id">
                                        <td class="celda-id">{{ detalle.id }}</td>
                                        <td class="celda-entidad"><div class="entidad-nombre" :title="detalle.detalle">{{ detalle.detalle }}</div></td>
                                        <td>
                                            <span :class="detalle.es_documento ? 'badge bg-success' : 'badge bg-secondary'">
                                                {{ detalle.es_documento ? 'Sí' : 'No' }}
                                            </span>
                                        </td>
                                        <td>
                                            <span :class="detalle.es_recojo ? 'badge bg-success' : 'badge bg-secondary'">
                                                {{ detalle.es_recojo ? 'Sí' : 'No' }}
                                            </span>
                                        </td>
                                        <td class="celda-id">{{ formatearFecha(detalle.created_at) }}</td>
                                        <td class="col-acciones">
                                            <button class="btn-icon btn-icon-edit" @click="editarDetalle(detalle)" title="Editar" aria-label="Editar">
                                                <i class="bi bi-pencil"></i>
                                            </button>
                                            <button class="btn-icon btn-icon-del" @click="eliminarDetalle(detalle.id)" title="Eliminar" aria-label="Eliminar">
                                                <i class="bi bi-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="!detallesEnvio.length" class="empty-row">
                                        <td colspan="6">No se encontraron detalles</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para Detalle de Envío -->
        <div v-if="showModalDetalle" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ modoEdicionDetalle ? 'Editar Detalle' : 'Nuevo Detalle' }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalDetalle"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="guardarDetalle">
                            <div class="mb-3">
                                <label for="detalleTexto" class="form-label required">Detalle</label>
                                <input 
                                    type="text" 
                                    class="form-control" 
                                    id="detalleTexto" 
                                    v-model="formDetalle.detalle"
                                    :class="{ 'is-invalid': errorsDetalle.detalle }"
                                    placeholder="Ingrese el detalle"
                                    maxlength="255"
                                    required
                                >
                                <div v-if="errorsDetalle.detalle" class="invalid-feedback">
                                    {{ errorsDetalle.detalle }}
                                </div>
                            </div>
                            
                            <div class="mb-3">
                                <div class="form-check">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        id="esDocumento" 
                                        v-model="formDetalle.es_documento"
                                    >
                                    <label class="form-check-label" for="esDocumento">
                                        Es Documento
                                    </label>
                                </div>
                            </div>
                            
                            <div class="mb-3">
                                <div class="form-check">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        id="esRecojo" 
                                        v-model="formDetalle.es_recojo"
                                    >
                                    <label class="form-check-label" for="esRecojo">
                                        Es Recojo
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalDetalle">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="guardarDetalle" :disabled="isLoading">
                            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                            {{ modoEdicionDetalle ? 'Actualizar' : 'Guardar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>



    </div>

</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import PaginacionListado from '@/components/PaginacionListado.vue'
import paginacionLocal from '@/mixins/paginacionLocal'

export default {
    name: 'GestionMetodoEnvio',
    components: { PaginacionListado },
    mixins: [paginacionLocal],
    data() {
        return {
            isLoading: false,
            
            // Modales
            showModalMetodo: false,
            showModalDetalles: false,
            showModalDetalle: false,
            
            // Modos de edición
            modoEdicion: false,
            modoEdicionDetalle: false,
            
            // Datos
            metodosEnvio: [],
            detallesEnvio: [],
            metodoSeleccionado: null,
            
            // Formularios
            formMetodo: {
                id: null,
                codigo: ''
            },
            formDetalle: {
                id: null,
                detalle: '',
                es_documento: false,
                es_recojo: false,
                cod_metodo_envio_id: null
            },
            
            // Errores
            errors: {},
            errorsDetalle: {}
        }
    },
    async mounted() {
        await this.cargarMetodosEnvio()
    },
    methods: {
        // Formatear fecha
        formatearFecha(fecha) {
            if (!fecha) return '-'
            return new Date(fecha).toLocaleString('es-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        // MÉTODOS DE ENVÍO
        async cargarMetodosEnvio() {
            this.isLoading = true
            try {
                const response = await axios.get('cod-metodo-envio')
                this.metodosEnvio = response.data
            } catch (error) {
                console.error('Error cargando métodos de envío:', error)
                Swal.fire('Error', 'Error al cargar los métodos de envío', 'error')
            } finally {
                this.isLoading = false
            }
        },

        abrirModalMetodoEnvio() {
            this.modoEdicion = false
            this.formMetodo = {
                id: null,
                codigo: ''
            }
            this.errors = {}
            this.showModalMetodo = true
        },

        editarMetodoEnvio(metodo) {
            this.modoEdicion = true
            this.formMetodo = {
                id: metodo.id,
                codigo: metodo.codigo
            }
            this.errors = {}
            this.showModalMetodo = true
        },

        cerrarModalMetodo() {
            this.showModalMetodo = false
            this.formMetodo = {
                id: null,
                codigo: ''
            }
            this.errors = {}
        },

        async guardarMetodoEnvio() {
            this.errors = {}
            
            if (!this.formMetodo.codigo.trim()) {
                this.errors.codigo = 'El código es requerido'
                return
            }

            this.isLoading = true
            try {
                if (this.modoEdicion) {
                    await axios.put(`cod-metodo-envio/${this.formMetodo.id}`, {
                        codigo: this.formMetodo.codigo.trim()
                    })
                    Swal.fire('Éxito', 'Método de envío actualizado correctamente', 'success')
                } else {
                    await axios.post('cod-metodo-envio', {
                        codigo: this.formMetodo.codigo.trim()
                    })
                    Swal.fire('Éxito', 'Método de envío creado correctamente', 'success')
                }
                
                this.cerrarModalMetodo()
                await this.cargarMetodosEnvio()
            } catch (error) {
                console.error('Error guardando método de envío:', error)
                if (error.response?.data?.errors) {
                    this.errors = error.response.data.errors
                } else {
                    Swal.fire('Error', error.response?.data?.message || 'Error al guardar el método de envío', 'error')
                }
            } finally {
                this.isLoading = false
            }
        },

        async eliminarMetodoEnvio(id) {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            })

            if (result.isConfirmed) {
                this.isLoading = true
                try {
                    await axios.delete(`cod-metodo-envio/${id}`)
                    Swal.fire('Eliminado', 'Método de envío eliminado correctamente', 'success')
                    await this.cargarMetodosEnvio()
                } catch (error) {
                    console.error('Error eliminando método de envío:', error)
                    Swal.fire('Error', error.response?.data?.message || 'Error al eliminar el método de envío', 'error')
                } finally {
                    this.isLoading = false
                }
            }
        },

        // GESTIÓN DE DETALLES
        async verDetalles(metodo) {
            this.metodoSeleccionado = metodo
            await this.cargarDetallesEnvio(metodo.id)
            this.showModalDetalles = true
        },

        cerrarModalDetalles() {
            this.showModalDetalles = false
            this.metodoSeleccionado = null
            this.detallesEnvio = []
        },

        async cargarDetallesEnvio(codMetodoEnvioId) {
            this.isLoading = true
            try {
                const response = await axios.get(`detalle-envio-by-codigo-gestion/${codMetodoEnvioId}`)
                this.detallesEnvio = response.data
            } catch (error) {
                console.error('Error cargando detalles de envío:', error)
                this.detallesEnvio = []
            } finally {
                this.isLoading = false
            }
        },

        // DETALLES DE ENVÍO
        abrirModalDetalle() {
            this.modoEdicionDetalle = false
            this.formDetalle = {
                id: null,
                detalle: '',
                es_documento: false,
                es_recojo: false,
                cod_metodo_envio_id: this.metodoSeleccionado.id
            }
            this.errorsDetalle = {}
            this.showModalDetalle = true
        },

        editarDetalle(detalle) {
            this.modoEdicionDetalle = true
            this.formDetalle = {
                id: detalle.id,
                detalle: detalle.detalle,
                es_documento: Boolean(detalle.es_documento),
                es_recojo: Boolean(detalle.es_recojo),
                cod_metodo_envio_id: detalle.cod_metodo_envio_id
            }
            this.errorsDetalle = {}
            this.showModalDetalle = true
        },

        cerrarModalDetalle() {
            this.showModalDetalle = false
            this.formDetalle = {
                id: null,
                detalle: '',
                es_documento: false,
                es_recojo: false,
                cod_metodo_envio_id: null
            }
            this.errorsDetalle = {}
        },

        async guardarDetalle() {
            this.errorsDetalle = {}
            
            if (!this.formDetalle.detalle.trim()) {
                this.errorsDetalle.detalle = 'El detalle es requerido'
                return
            }

            this.isLoading = true
            try {
                const data = {
                    detalle: this.formDetalle.detalle.trim(),
                    es_documento: this.formDetalle.es_documento ? 1 : 0,
                    es_recojo: this.formDetalle.es_recojo ? 1 : 0,
                    cod_metodo_envio_id: this.formDetalle.cod_metodo_envio_id
                }

                if (this.modoEdicionDetalle) {
                    await axios.put(`detalle-envio/${this.formDetalle.id}`, data)
                    Swal.fire('Éxito', 'Detalle actualizado correctamente', 'success')
                } else {
                    await axios.post('detalle-envio', data)
                    Swal.fire('Éxito', 'Detalle creado correctamente', 'success')
                }
                
                this.cerrarModalDetalle()
                await this.cargarDetallesEnvio(this.metodoSeleccionado.id)
            } catch (error) {
                console.error('Error guardando detalle:', error)
                if (error.response?.data?.errors) {
                    this.errorsDetalle = error.response.data.errors
                } else {
                    Swal.fire('Error', error.response?.data?.message || 'Error al guardar el detalle', 'error')
                }
            } finally {
                this.isLoading = false
            }
        },

        async eliminarDetalle(id) {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            })

            if (result.isConfirmed) {
                this.isLoading = true
                try {
                    await axios.delete(`detalle-envio/${id}`)
                    Swal.fire('Eliminado', 'Detalle eliminado correctamente', 'success')
                    await this.cargarDetallesEnvio(this.metodoSeleccionado.id)
                } catch (error) {
                    console.error('Error eliminando detalle:', error)
                    Swal.fire('Error', error.response?.data?.message || 'Error al eliminar el detalle', 'error')
                } finally {
                    this.isLoading = false
                }
            }
        }
    }
}


</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    color: white;
}

.modal.show {
    display: block !important;
}

.badge {
    font-size: 0.8em;
}

.text-danger {
    color: #dc3545 !important;
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
}

.required::after {
    content: ' *';
    color: red;
}

</style>